import type React from 'react';
import { Box, Card, DuoColorIcon, Heading, Icon, Paragraph, Text } from '@zillow/constellation-10';
import { IconDollarSignCircleFilled, IconHouseUserFilled, IconSearchFilled } from '@zillow/constellation-icons';
import { ClickstreamAuthTriggerSource, ClickstreamTriggerObject } from '../../analytics/events';
import FlexibleLandlordIcon from '../../assets/FlexibleLandlord.svg';
import Image from 'next/image';
import { BenefitSection } from './elements/BenefitSection';
import RequestZillowPaymentsModal from './elements/RequestZillowPaymentsModal';

export default function PrivacyNoticeScreen() {
  return (
    <Box css={{ marginTop: 'loose' }}>
      <Box
        css={{
          display: 'flex',
          gap: 'looser',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexDirection: 'column',
          '@media (min-width: 1024px)': {
            flexDirection: 'row',
          },
        }}
      >
        <Box css={{ flex: 1, maxWidth: '762px' }}>
          <Heading level={2} textStyle="heading-md" css={{ marginBottom: 'loose' }}>
            Here’s how it works
          </Heading>

          <Box css={{ marginBottom: 'loose' }}>
            <BenefitSection
              icon={
                <DuoColorIcon tone="info" onBackground="impact">
                  <Icon>
                    <IconHouseUserFilled />
                  </Icon>
                </DuoColorIcon>
              }
              title="Enter your personal details"
            >
              Sign in or create a Zillow account. We’ll share your email with our partner, Esusu, to set up rent
              reporting and credit monitoring on Zillow.
            </BenefitSection>

            <BenefitSection
              icon={
                <DuoColorIcon tone="info" onBackground="impact">
                  <Icon>
                    <IconDollarSignCircleFilled />
                  </Icon>
                </DuoColorIcon>
              }
              title="Link your bank account"
            >
              Using Plaid, securely connect your bank account.
            </BenefitSection>

            <BenefitSection
              icon={
                <DuoColorIcon tone="info" onBackground="impact">
                  <Icon>
                    <IconSearchFilled />
                  </Icon>
                </DuoColorIcon>
              }
              title="Identify past rent payments"
            >
              Choose your rent payments from the past 24 months.
            </BenefitSection>
          </Box>

          <Paragraph css={{ textStyle: 'body-lg', marginBottom: 'loose' }}>
            Sign up today for just <strong>$20 yearly</strong>.
          </Paragraph>
        </Box>

        <Card
          elevated={false}
          css={{
            width: '100%',
            padding: 'default',
            alignSelf: 'flex-start',
            '@media (min-width: 1024px)': {
              width: '320px',
              maxWidth: '320px',
            },
          }}
        >
          <Box css={{ marginBottom: 'tight' }}>
            <Image src={FlexibleLandlordIcon} alt="" width={120} height={120} />
          </Box>

          <Text textStyle="body-bold">Is your landlord flexible?</Text>

          <Paragraph
            css={{
              textStyle: 'body-sm',
              textAlign: 'left',
              marginBottom: 'tight',
            }}
          >
            Ask them to pay rent with Zillow and get access to rent reporting for <strong>free</strong>.
          </Paragraph>

          <Box css={{ textAlign: 'left' }}>
            <RequestZillowPaymentsModal
              ctaText="Request Zillow payments"
              clickstreamTriggerObject={ClickstreamTriggerObject.WIZARD_UPSELL}
              authTriggerSource={ClickstreamAuthTriggerSource.ZRM_REQUEST_UPSELL}
              triggerAs="textButton"
            />
          </Box>
        </Card>
      </Box>
    </Box>
  );
}
